<template lang="pug">
.page-container
  .header-bg
  .header-container(v-if="store.levelInfo")
    .level-panel
      .level
        span.level-score {{ store.levelInfo.currentPoint }}
        span.level-name 成长值
      .level-title
        img.level-title-icon(:src="store.levelInfo.currentLevel.levelIcon")
        span {{ store.levelInfo.currentLevel.levelName }}

    .score-panel
      .score-tips {{ upgradeTips }}
      .score-bar
        .score-bar-current(:style="barStyle")
        .score-point(:style="holdPointStyle")
        .score-point-text(:style="holdPointStyle") 保级{{ store.levelInfo.currentLevel.growthPoint }}
        .score-point(:style="upgradePointStyle" v-if="store.levelInfo.nextLevel")
        .score-point-text(:style="upgradePointStyle" v-if="store.levelInfo.nextLevel")
          | 晋升{{ store.levelInfo.nextLevel.growthPoint }}

    .level-card
      .level-card-item
        .title 等级有效期
        .desc {{ store.levelInfo.upgradeDateStr }} - {{ store.levelInfo.endDateStr }}
      .level-card-item(v-if="nextLevel")
        .title 下一周期等级预计
        .desc {{ nextLevel.levelName }}

  .info
    .info-tabs
      .tab-item(
        :class="{active: activeTab===0}"
        @click="equity"
      ) 已解锁权益
      .tab-item(
        :class="{active: activeTab===1}"
        @click="growth"
      ) 成长值明细
    .info-body(
      v-infinite-scroll="loadGrowthBill"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    )
      .rights-list(v-if="activeTab===0")
        .rights
          .rights-item(
            v-for="item in unlockedPropertyList"
            @click="() => handleClickRight(item)"
          )
            img.rights-item-img(:src="item.propActiveIcon")
            span.rights-item-text {{ item.propName }}
        .title 升级可解锁以下权益
        .rights
          .rights-item(
            v-for="item in lockedPropertyList"
            @click="() => handleClickRight(item)"
          )
            img.rights-item-img(src="@/assets/member/icon_suo@2x.png")
            span.rights-item-text {{ item.propName }}
      .info-list(v-if="activeTab===1")
        .info-item(
          v-for="item in taskLog"
          :key="item.guid"
        )
          .body-left
            .info-item-text {{ item.taskName }}
            .info-item-desc {{ item.completeDateStr }}
          .body-right
            .info-item-text +{{ item.point }}
        .loading(v-if="loading") 加载中
        .no-more(v-if="taskLog.length && !hasMore") - 已显示所有数据 -
        .no-more(v-if="!taskLog.length && !hasMore") - 暂无数据 -

</template>
<script>
import { Native } from '@hb/NBridge/lib/h5';
import { InfiniteScroll } from 'mint-ui';
import { getUserNextReachLevel, queryGrowthBill } from '@/api/member';
import { format } from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  store,
  loadUserLevelInfo,
  initUserBaseInfo,
  initBaseProperty,
  updateUserProperty,
} from './store';

const BASE_WIDTH = 90;
export default {
  directives: {
    InfiniteScroll,
  },
  data() {
    return {
      store: store.state,
      activeTab: 0,
      upgradePointStyle: {
        left: `${BASE_WIDTH}%`,
      },
      holdPointStyle: {
        left: `${100 - BASE_WIDTH}%`,
      },
      nextLevel: {},
      taskLog: [],
      hasMore: true,
      loading: false,
      init: true,
    };
  },
  computed: {
    upgradeTips() {
      const arr = [];
      const { currentPoint, currentLevel, nextLevel } = this.store.levelInfo;
      const { growthPoint: currentGrowthPoint } = currentLevel;
      const { growthPoint: nextGrowthPoint, levelName } = nextLevel || {};
      if (currentPoint >= currentGrowthPoint) {
        arr.push('保级成功');
        if (nextGrowthPoint) {
          arr.push(`差${Math.round(nextGrowthPoint - currentPoint)}升级${levelName}`);
        }
      } else {
        arr.push(`还差${Math.round(currentGrowthPoint - currentPoint)}成长值保级`);
      }
      return arr.join('，');
    },
    barStyle() {
      const { currentPoint, currentLevel, nextLevel } = this.store.levelInfo;
      const { growthPoint: currentGrowthPoint } = currentLevel;
      const { growthPoint: nextGrowthPoint } = nextLevel || {};
      const leftWidth = 100 - BASE_WIDTH;
      if (currentPoint < currentGrowthPoint) {
        return {
          width: `${(currentPoint / currentGrowthPoint) * leftWidth}%`,
        };
      }
      const currentExtraPointWidth = (
        (currentPoint - currentGrowthPoint) / (nextGrowthPoint - currentGrowthPoint)
      ) * ((2 * BASE_WIDTH) - 100);
      if (nextGrowthPoint) {
        return {
          width: `${leftWidth + currentExtraPointWidth}%`,
        };
      }
      return {
        width: `${leftWidth}%`,
      };
    },
    unlockedPropertyList() {
      return this.store.propertyList.filter((p) => p.propStatus === 1);
    },
    lockedPropertyList() {
      return this.store.propertyList.filter((p) => p.propStatus === 0);
    },
  },
  async mounted() {
    UBT.moduleExpose({
      pageId: 'platform_LVVIP_growth_value',
      categoryId: 'platform',
      moduleId: 'platform_growth_value',
      contentId: 'platform_growth_value',
      exposureTimes: 1,
      businessInfo: {},
    });
    UBT.moduleExpose({
      pageId: 'platform_LVVIP_growth_value',
      categoryId: 'platform',
      moduleId: 'platform_usable_rights',
      contentId: 'platform_usable_rights',
      exposureTimes: 1,
      businessInfo: {},
    });
    UBT.pageView({
      pageId: 'platform_LVVIP_growth_value',
      categoryId: 'platform',
      businessInfo: {},
    });
    Native.callNative({
      method: 'setNavigationBar',
      params: {
        title: '会员中心',
        backgroundColor: '#4db2ff',
      },
    });

    if (this.$route.query.type) {
      this.activeTab = Number(this.$route.query.type) || 0;
    }

    await initUserBaseInfo();
    this.init = false;

    loadUserLevelInfo();
    initBaseProperty()
      .then(updateUserProperty);
    this.loadUserNextReachLevel();
    this.loadGrowthBill();
  },
  destroyed() {
    UBT.pageViewOut({
      pageId: 'platform_LVVIP_growth_value',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    equity() {
      this.activeTab = 0;
      UBT.clickButton({
        pageId: 'platform_LVVIP_growth_value',
        buttonName: 'platform_usable_rights',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    growth() {
      this.activeTab = 1;
      UBT.clickButton({
        pageId: 'platform_LVVIP_growth_value',
        buttonName: 'platform_growth_value',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async loadUserNextReachLevel() {
      try {
        const { data } = await getUserNextReachLevel(store.baseParams);
        this.nextLevel = data || {};
      } catch (ex) {
        this.nextLevel = {};
      }
    },
    handleClickRight(item) {
      UBT.clickButton({
        pageId: 'platform_LVVIP_growth_value',
        buttonName: 'platform_usable_rights',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$router.push({
        name: 'memberRights',
        query: {
          guid: item.propGuid,
        },
      });
    },
    async loadGrowthBill() {
      if (!this.hasMore || this.init) return;
      if (this.lastTime && (Date.now() - this.lastTime) < 100) {
        return;
      }
      this.lastTime = Date.now();

      try {
        this.loading = true;

        const { data = {} } = await queryGrowthBill({
          pageSize: 10,
          lastRecordId: this.lastRecordId,
          ...store.baseParams,
        });
        this.taskLog = this.taskLog.concat((data.pageData || []).map((p) => ({
          completeDateStr: format(p.completeDate, 'yyyy.MM.dd'),
          ...p,
        })));
        this.hasMore = data.hasMore;
        this.lastRecordId = this.taskLog[this.taskLog.length - 1].guid;
      } catch (ex) {
        this.taskLog = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .header-bg {
    width: 150%;
    position: absolute;
    left: -25%;
    height: 200px;
    background-color: #4db2ff;
    border-bottom-left-radius: 100%;
    border-bottom-right-radius: 100%;
  }

  .info {
    flex: 1;
    overflow-y: auto;
    background: #fff;
    display: flex;
    flex-direction: column;

    .info-tabs {
      display: flex;
      padding: 0 0.2rem;
      border-bottom: solid 1px #f1f1f1;

      .tab-item {
        position: relative;
        font-size: 14px;
        color: #666;
        line-height: 20px;
        margin-right: 0.3rem;
        padding-bottom: 0.11rem;

        &.active {
          color: #333;
          font-weight: 400;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 0.3rem;
            height: 0.04rem;
            background: #0b82f1;
            border-radius: 0.02rem;
          }
        }
      }
    }

    .info-body {
      flex: 1;
      overflow-y: auto;
    }

    .info-list {
      padding-bottom: 12px;

      .info-item {
        display: flex;
        justify-content: space-between;
        padding: 0.15rem 0.2rem;

        &:not(:last-child) {
          border-bottom: solid 1px rgba(238, 238, 238, 0.5);
        }

        .info-item-text {
          font-size: 16px;
          line-height: 22px;
          color: #333;
          margin-bottom: 0.04rem;
        }

        .info-item-desc {
          color: #999;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    .rights {
      padding: 0.2rem 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      padding-bottom: 0.05rem;

      .rights-item {
        display: flex;
        width: 25%;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.2rem;

        .rights-item-img {
          width: 0.52rem;
          height: 0.52rem;
          margin-bottom: 0.06rem;
        }

        .rights-item-text {
          display: block;
          color: #666;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }

    .title {
      padding: 0 0.2rem;
      font-size: 14px;
      color: #333;
      line-height: 20px;
    }
  }

  .header-container {
    z-index: 1;
    padding: 0.2rem 0.2rem 0;
    margin-bottom: 0.2rem;

    .level-panel {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      margin-bottom: 0.2rem;

      .level {
        display: flex;
        align-items: baseline;

        .level-score {
          font-size: 0.32rem;
          line-height: 0.37rem;
          margin-right: 0.06rem;
        }

        .level-name {
          font-size: 12px;
          line-height: 17px;
        }
      }

      .level-title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 0.15rem;
        padding: 0 0.15rem;
        height: 0.3rem;

        .level-title-icon {
          width: 0.2rem;
          height: 0.2rem;
          margin-right: 0.04rem;
        }
      }
    }

    .score-panel {
      font-size: 12px;
      color: #fff;
      line-height: 17px;
      margin-bottom: 0.5rem;

      .score-tips {
        width: 100%;
        text-align: right;
        margin-bottom: 0.1rem;
      }

      .score-bar {
        position: relative;
        width: 3.35rem;
        height: 0.06rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 0.05rem;

        .score-bar-current {
          position: absolute;
          z-index: 1;
          background: rgba(255, 255, 255, 1);
          border-radius: 0.05rem;
          height: 100%;
        }

        .score-point {
          display: inline-block;
          background: #fff;
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 0.1rem;
          position: absolute;
          z-index: 2;
          top: -0.025rem;
          margin-left: -0.1rem;
        }

        .score-point-text {
          display: block;
          position: absolute;
          z-index: 2;
          top: 0.15rem;
          white-space: nowrap;
          word-break: keep-all;
          transform: translateX(-40%);
        }
      }
    }

    .level-card {
      width: 3.35rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 2px 6px 0 rgba(85, 104, 149, 0.1);
      border-radius: 4px;
      padding: 0.15rem 0;
      display: flex;

      .level-card-item {
        text-align: center;
        flex: 1;

        &:not(:last-child) {
          border-right: solid 1px #f1f1f1;
        }

        .title {
          color: #999;
          font-size: 12px;
          margin-bottom: 0.1rem;
        }

        .desc {
          color: #333;
          font-size: 15px;
          line-height: 21px;
        }
      }
    }
  }
}

.loading,
.no-more {
  font-size: 12px;
  color: #ccc;
  text-align: center;
  line-height: 40px;
}
</style>
